import { render } from "./KeywordsModal.vue?vue&type=template&id=bb91b1ac&scoped=true"
import script from "./KeywordsModal.vue?vue&type=script&lang=js"
export * from "./KeywordsModal.vue?vue&type=script&lang=js"

import "./KeywordsModal.vue?vue&type=style&index=0&id=bb91b1ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb91b1ac"]])

export default __exports__